import React from 'react';
import { Alert, Row, Col } from 'components';

export const FinalStatusBanner = ({ status }: { status: string }) => (
  <Row>
    <Col span={24}>
      <Alert
        style={{ width: '100%' }}
        message={`This lead is in a final status (${status === 'REJECTED' ? 'Rejected' : 'Converted'}) and cannot be modified further.`}
        type="warning"
        showIcon
      />
    </Col>
  </Row>
);
